import React,  { useEffect, useState } from 'react';
import {
  Card,
  Col,
  Row,
  Button,
  Container,
  FormCheckbox
} from "shards-react";
import Table from './Table';
import { useLocation, useHistory } from "react-router-dom";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { setDateForTable } from '../../utils/date';
import {default as queryString} from "qs";
import { formatNumberAmount, getFrequencyLabel, parsingUserProfileSavingObject } from '../../utils/general';
import { SUBSCRIBER_BILLING_ADMIN, SUBSCRIBER_SYNC_TYPE } from '../../utils/constants';
import CRBadge from '../common/CRBadge';
function EapInfo({
  formData,
  userProfile,
  formDataRef,
  sectionformDataRef,
  clientMarkups,
  setFormData,
  syncApi,
  attachApi,
  setAlert,
  userRole,
  saveUserProfile,
  roleSelected,
  confirmAlert,
  setConfirmAlert,
  setAutoSaved,
  changeRequestedFields = {},
}) {

  const [viewHistory, setViewHistory] = useState(false);
  const [isDisabledEAP, disableEAP] = useState(false);
  const location = useLocation();
  const history = useHistory();
  let queryParams = queryString.parse(location.search.replace("?", ""))
  const [disabledAttachPayItem, setDisabledAttachPayItem] = 
    useState(userRole?.selectedrole === SUBSCRIBER_BILLING_ADMIN.ADMIN || userRole?.selectedrole === SUBSCRIBER_BILLING_ADMIN.BILLING);
  
  const onChangeSync = async (EAPId, isChecked) => {
    if (!isChecked) {
      //Need to check it records is being saved in backend
      compareEAPInfoForSaving(EAPId);
    }
  }

  const onEditEAP = (row) => {
    history.push({
      pathname: `/EAP-info-form`,
      search:`?role=${queryParams.role}`,
      state: { userProfile, role: queryParams.role, row, formData, formDataRef, sectionformDataRef, clientMarkups, changeRequestedFields }
    });
  }

  const removingObject = (refNum)=>{
    let currentForms = formData.EAPInfos;
    let revisedArray = currentForms.filter(x => x.EAPId !== refNum);
    let formRevised = {...formData}
    formRevised.EAPInfos = revisedArray;
    setFormData({... formRevised})
  }

  const onDeleteEAP = (row) => {
    setConfirmAlert({
      ...confirmAlert,
      confirmMsg: 'Deleting this EAP cannot be undone. Do you wish to proceed, Yes or No?',
      visible: true,
      onConfirm: async () => {
        setConfirmAlert({ ...confirmAlert, visible: false })
        removingObject(row.EAPId);
      }
    })
  }
  
  const hasRecordCR = (recordId) =>
    recordId != null && Object.keys(changeRequestedFields).some(k => k.startsWith(`eapinfos[${recordId}].`));

  const tableColumns = [
    {
      Header: <span className="text-wrap">EAP Provider</span>,
      accessor: "EAPProvider",
      maxWidth: 120,
      minWidth: 120,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",

    },
    {
      Header: <span className="text-wrap">EAP Start Date</span>,
      accessor: "EAPStartDate",
      maxWidth: 110,
      minWidth: 110,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",
      cell: (row) => setDateForTable(row.EAPStartDate)
    },
    {
      Header: <span className="text-wrap">EAP End Date</span>,
      accessor: "EAPEndDate",
      maxWidth: 100,
      minWidth: 100,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",
      cell: (row) => setDateForTable(row.EAPEndDate)
    },
    {
      Header: <span className="text-wrap">EAP Deduction Frequency</span>,
      accessor: "EAPDeductionFrequency",
      maxWidth: 186,
      minWidth: 186,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",
      cell: row=> getFrequencyLabel(row.EAPDeductionFrequency)
    },

    {
      Header: <span className="text-wrap">EAP Contribution Currency</span>,
      accessor: "EAPContributionCurrency",
      maxWidth: 190,
      minWidth: 190,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",

    },

    {
      Header: <span className="text-wrap">EAP Contribution Amount</span>,
      accessor: "EAPContributionAmount",
      maxWidth: 184,
      minWidth: 184,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-right",
      cell : row=> formatNumberAmount(row.EAPContributionAmount, "en-US", 2, 2)
    },
    {
      Header: <span className="text-wrap">Sync Pay Item</span>,
      accessor: "syncPayItem",
      maxWidth: 70,
      minWidth: 70,
      className: "justify-content-center text-center text-break",
      bodyClassName: "justify-content-center text-center",
      cell : row => <div className={"d-flex justify-content-center text-bold " + ( Number(row.syncPayItem) === 1 ? "text-success" : "text-danger" )} >
        <FormCheckbox checked={ Number(row.syncPayItem) === 1 ?? false } 
          onChange={() => { if(disabledAttachPayItem){
              onChangeSync(row.EAPId, Number(row.syncPayItem) === 1 ?? false) 
            }
            else 
              return false;
          }}
        >
          { Number(row.syncPayItem) === 1 ? 'Synced' : 'Not Synced'}
        </FormCheckbox></div>
    },
    {
      Header: <span className="text-wrap">Action</span>,
      accessor: "EAPId",
      maxWidth: 50,
      minWidth: 50,
      className: "justify-content-center text-center text-wrap text-break",
      bodyClassName: "text-center",
      cell: (row) => (
        <span>{hasRecordCR(row.recordId) && <CRBadge />}<img src="./icons/edit-square.svg" role="button" height="17.5" width="17.5" className="mr-2" onClick={() => {
          onEditEAP(row);
        }}></img>
        <img role="button" src="./icons/cross-icon.png" height="17.5" width="17.5" onClick={() =>
          onDeleteEAP(row)}>
        </img></span>
        //<Link to={{ pathname: `/EAP-info-form`, search:`?role=${queryParams.role}`, state: { userProfile, role: queryParams.role, row, formData, formDataRef, sectionformDataRef,clientMarkups } }}>{row.EAPId === 0 ? 'New' : row.EAPId}</Link>
      )
    },


  ];

  const togleHistory = () => {
    setViewHistory(!viewHistory);

  }

  useEffect(()=>{

    if(formData.EAPApplicable === 'Yes'){
      disableEAP(true); 
    }

  },[formData])

  ///----> Compare and Saving part <----///

  const compareEAPInfoForSaving = async (refNumber) => {
    if (formData.EAPInfos.length > sectionformDataRef.EAPInfos.length) {
      setConfirmAlert({
        ...confirmAlert,
        confirmMsg: 'EAP is not saved. Would you like to save it now?',
        visible: true,
        onConfirm: async () => {

          setConfirmAlert({ ...confirmAlert, visible: false })
          setAutoSaved(true);
          let profileSaved = await parseModuleObjectForSave();
          if (profileSaved) {
            syncPayItemWithUser(refNumber);
            setAutoSaved(false);
          }
        }
      })
    }
    else {
      syncPayItemWithUser(refNumber);
    }
  }

  async function parseModuleObjectForSave() {
    let savingObject = parsingUserProfileSavingObject(formData, sectionformDataRef, formDataRef, roleSelected);
    if (savingObject !== undefined && savingObject.flag) {
      let response = await saveUserProfile(savingObject.finalData);
      return response;
    }
    else {
      setAlert(savingObject.errorMessage, "danger");
      return savingObject.flag;
    }
  }

  const syncPayItemWithUser = async (EAPId) => {
    //Note : If condition is removed as now every item will set sync if its not synced -> New logic
    //call an API 
    let response = await syncApi(formData.userId, SUBSCRIBER_SYNC_TYPE.EAP, EAPId );

    if (response) {
      formData.EAPInfos = formData.EAPInfos.map((x) => {
        //if(x.EAPId === EAPId){
          x.syncPayItem = 1;
          x.payItemRefNum = response;
        //}
        return x;
      })
      setFormData({ ...formData })

      sectionformDataRef.EAPInfos = sectionformDataRef.EAPInfos.map((x) => {
        //if (x.EAPId === EAPId) {
          x.syncPayItem = 1;
          x.payItemRefNum = response;
        //}
        return x;
      })
    } 
  }

  /// ---- > End < ---- ///

  const eapCREntries = Object.entries(changeRequestedFields).filter(([k]) => k.startsWith('eapinfos'));
  const eapHasCR = eapCREntries.length > 0;
  const eapCRTooltip = eapCREntries.map(([k, v]) => `${k.split('.')[1]}: ${v.newValue ?? '-'}`).join(', ');

  return (
    <Card id="EapInfo" small

      className="mb-5 w-100 d-flex personalParent">
      <span className="iconBox"><i className="fa-solid fa-umbrella iconStyle" /></span>
      <h4 className="m-0 section-title headerStyle pr-0">Employee Assistance Program Information <spen className="d-inline" ><FormCheckbox id="history" name="history"
        className="d-inline"
        checked={isDisabledEAP} onChange={() => {
          formData.EAPApplicable = formData.EAPApplicable == 'Yes' ? 'No' :'Yes';
          disableEAP(!isDisabledEAP)
        }}
        toggle small></FormCheckbox></spen></h4>
      
      <Container fluid className="file-manager__filters border-bottom">
        <Row className="mb-4">

          <Col lg="10"
            className="d-flex flex-row-reverse">

            <div className='d-flex flex-column ml-3 section-card-header'>
              <spen className="header-checkbox">
                <FormCheckbox id="history" name="history"
                  checked={viewHistory} onChange={togleHistory}
                  toggle small><spen className="font-weight-bold text-center">View EAP History</spen></FormCheckbox>
              </spen>
              <spen className="font-weight-bold text-center">


              </spen>
              <spen className="font-weight-bold font-italic">Note - Highlighted in blue row is the active EAP information.</spen>
            </div>
            <div></div>

          </Col>
          
          <Col lg="2"
            className=" pt-0 pl-0 pb-0 pr-2 file-manager__filters__search d-flex align-items-center justify-content-center justify-content-md-end col-6" >

<Button disabled={!isDisabledEAP} className="my-2 py-2 pr-0 pl-0 mx-2 w-100" size='sm'
                theme="accent"
                onClick={() => { 

                  history.push({
                    pathname: `/EAP-info-form`,
                    search:`?role=${queryParams.role}`,
                    state: {
                      userProfile,
                      refNum: 0,
                      role:queryParams.role,
                      formData,
                      formDataRef,
                      sectionformDataRef,
                      clientMarkups,
                      changeRequestedFields,
                    },
                  });
                }}
                ><spen>Add EAP</spen></Button>
            {eapHasCR && (
              <div className="text-right mt-1">
                <CRBadge newValue={eapCRTooltip} placement="left" />
              </div>
            )}


          {/*<Link className="btn-primary" to={{ pathname: `/placement-info-form`, state: { userProfile, refNum: 0 } }} disabled={userProfile.personalInfo === undefined} theme="accent" state>
            Add Compensation
              </Link>*/}
          </Col>

        </Row>
       

        <div className='scrollabe-table-container'>
          {

            (formData && formData.EAPInfos) ?
              (<Table headers={tableColumns} rows={formData.EAPInfos.filter(x => x.EAPId !== 0)} viewHistory={viewHistory} />)
             :
              (<Table headers={tableColumns} rows={[]} viewHistory={viewHistory} />)
          }
        </div>
      </Container>




    </Card>
  );
}

export default EapInfo;
